/**
 * Handles tab switching functionality for Product Q&A section
 */
function handleProductQATabs() {
  const tabButtons = document.querySelectorAll(".mc-product-qa__tab-btn");
  const tabContents = document.querySelectorAll(".mc-product-qa__tab-content");

  if (!tabButtons.length || !tabContents.length) {
    console.warn("Product Q&A tab elements not found");
    return;
  }

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const targetTab = this.getAttribute("data-tab");

      // Remove active class from all buttons
      tabButtons.forEach((btn) => {
        btn.classList.remove("mc-product-qa__tab-btn--active");
        btn.setAttribute("aria-selected", "false");
      });

      // Hide all tab contents
      tabContents.forEach((content) => {
        content.classList.remove("mc-product-qa__tab-content--active");
        content.setAttribute("aria-hidden", "true");
      });

      // Activate clicked button
      this.classList.add("mc-product-qa__tab-btn--active");
      this.setAttribute("aria-selected", "true");

      // Show corresponding content
      const targetContent = document.querySelector(
        `[data-tab-content="${targetTab}"]`
      );
      if (targetContent) {
        targetContent.classList.add("mc-product-qa__tab-content--active");
        targetContent.setAttribute("aria-hidden", "false");
      }
    });
  });
}

/**
 * Handles voting functionality for Q&A items
 */
function handleProductQAVoting() {
  const voteButtons = document.querySelectorAll(".mc-product-qa__vote-btn");

  if (!voteButtons.length) {
    console.warn("Product Q&A vote buttons not found");
    return;
  }

  voteButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const voteType = this.getAttribute("data-vote");
      const qaId = this.getAttribute("data-qa-id");
      const countElement = this.querySelector(".mc-product-qa__vote-count");

      // Get current count
      let currentCount = parseInt(countElement.textContent) || 0;

      // Check if user has already voted (using localStorage)
      const storageKey = `qa-vote-${qaId}-${voteType}`;
      const hasVoted = localStorage.getItem(storageKey);

      if (hasVoted) {
        // User already voted, show message or ignore
        console.log("User has already voted on this question");
        return;
      }

      // Increment count and update display
      currentCount++;
      countElement.textContent = currentCount;

      // Store vote in localStorage
      localStorage.setItem(storageKey, "true");

      // Add visual feedback
      this.style.opacity = "0.6";
      this.style.pointerEvents = "none";
    });
  });
}

// DOM Content Loaded - Initialize functionality
document.addEventListener("DOMContentLoaded", function () {
  handleProductQATabs();
  handleProductQAVoting();
});
